export const pluginID = 'oneacre-pergamon-fiscal';
export const authorization = 'Basic ZxZoaZMUQbUJDljA7kTExQ==';
